
import { ThemeProvider } from '@mui/material';
import React from 'react';
import './App.css';
import Template from './pages/template';
import { theme } from './theme';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Template />
      </ThemeProvider>
    </div>
  );
}

export default App;
